<a (click)="(menuItem?.subMenu && (menuItem?.subMenu!.length > 0)) ? openPanel(tempRef) : onMenuItemClick()" [routerLink]="menuItem?.link" mat-list-item
   routerLinkActive="mdc-list-item--activated">
  <mat-icon *ngIf="menuItem?.icon" class="material-symbols-outlined" matListItemIcon>{{menuItem?.icon}}</mat-icon>
  <div class="flex justify-content-between" matListItemTitle>
    <div class="align-self-center">{{menuItem?.label}}</div>
    <mat-icon *ngIf="menuItem?.subMenu && (menuItem?.subMenu!.length > 0)"
              class="text-color-secondary material-symbols-outlined">keyboard_arrow_right
    </mat-icon>
  </div>
</a>
<ng-template #tempRef>
  <app-menu-panel *ngIf="(menuItem?.subMenu && (menuItem?.subMenu!.length > 0))" [menu]="menuItem?.subMenu||[]"
                  [title]="menuItem?.label||''"></app-menu-panel>
</ng-template>
